import { createFileRoute } from '@tanstack/react-router';
import { ComparePage } from '~/components/pages/ComparePage';
import { loadInitialComparison } from '~/lib/compare';
import { loadInitialQuote } from '~/lib/quote';
import { pageHeadMeta } from '~/lib/seo';

export const Route = createFileRoute('/compare')({
  // Server-renders live nsave and competitor rates for the default corridor so
  // the cached HTML and crawlers see real figures; null falls back to the client
  // fetch. Not prerendered (see vite.config.ts), so these are never build-time values.
  // Loaders also run in the browser (hover preload, client navigation). There
  // RateComparison fetches after mount anyway, so skip the upstream calls rather
  // than doubling them and holding navigation for the render budget.
  loader: async () => {
    if (typeof window !== 'undefined') return { initialComparison: null, initialQuote: null };
    const [initialComparison, initialQuote] = await Promise.all([
      loadInitialComparison(),
      loadInitialQuote(),
    ]);
    return { initialComparison, initialQuote };
  },
  head: () =>
    pageHeadMeta({
      title: 'Compare nsave rates with other Alternatives',
      description: 'Compare nsave rates to other providers such as Wise, Payoneer, Xoom, OFX.',
      path: '/compare',
    }),
  component: CompareRoute,
});

function CompareRoute() {
  const { initialComparison, initialQuote } = Route.useLoaderData();
  return <ComparePage initialComparison={initialComparison} initialQuote={initialQuote} />;
}
